import { useState } from "react";
import { Flex, Modal, Space, Table, Typography } from "antd";
import type { TableProps } from "antd";
import { CiEdit } from "react-icons/ci";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { deleteTagCategorySlicce, TagCategory } from "../../redux/slices/categories.slice";
import { MdDeleteOutline } from "react-icons/md";
import { CategoryForm } from "../Forms/Category";
import ModalWrapper from "../Generic/modal";
import { useDeleteCategory } from "../../hooks/apis/categories";
import { AppDispatch } from "../../redux";
import { useDispatch } from "react-redux";
import { useMessageToast } from "../Layout/DefaultLayout";

const { confirm } = Modal;

type ColumnsType<T extends object> = TableProps<T>["columns"];

const CategoriesTable = ({ categories, loading, searchInput }: { categories: TagCategory[]; loading: boolean; searchInput: string }) => {
  const dispatch: AppDispatch = useDispatch();
  const { messageApi } = useMessageToast();

  const [editData, setEditData] = useState<TagCategory | null>(null);
  const [editCategoryModal, setEditCategoryModal] = useState(false);

  const { mutate: deleteCategory } = useDeleteCategory();

  const showDeleteConfirm = (name: string) => {
    confirm({
      title: "Are you sure you want to delete this category?",
      icon: <ExclamationCircleFilled />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        deleteCategory(name, {
          onSuccess: () => {
            dispatch(deleteTagCategorySlicce(name));
            messageApi.success("Category deleted successfully");
          },
        });
      },
    });
  };
  const columns: ColumnsType<TagCategory> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, { name }) => (
        <Flex gap={"10px"} align={"center"}>
          {" "}
          <Typography.Text strong>{name}</Typography.Text>
        </Flex>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (_, { description }) => <Typography.Text>{description}</Typography.Text>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <CiEdit
            style={{ cursor: "pointer" }}
            onClick={() => {
              setEditData(record);
              setEditCategoryModal(true);
            }}
          />
          <MdDeleteOutline style={{ cursor: "pointer" }} onClick={() => showDeleteConfirm(record.name)} />
        </Space>
      ),
    },
  ];

  return (
    <div>
      {editCategoryModal && editData && (
        <ModalWrapper title="Edit Category" isModalOpen={editCategoryModal} setIsModalOpen={setEditCategoryModal}>
          <CategoryForm setIsModal={setEditCategoryModal} editData={editData} />
        </ModalWrapper>
      )}
      <Table
        bordered={false}
        loading={loading}
        scroll={{ y: 450 }}
        style={{ width: "100%", height: "500px" }}
        columns={columns}
        pagination={categories.length > 10 && { position: ["bottomCenter"] }}
        dataSource={categories}
      />
    </div>
  );
};

export default CategoriesTable;
